

import { ReactNode } from 'react';
// import { UserGuard } from '@/shared/components/auth/RoleGuard'; // 削除済み

interface AdminPageWrapperProps {
  children: ReactNode;
  showErrorPage?: boolean;
}

/**
 * 管理者ページラッパーコンポーネント
 * 管理者権限が必要なページをラップするコンポーネント
 *
 * @param children - 子コンポーネント
 * @param showErrorPage - エラーページ表示フラグ
 * @returns 管理者ページラッパーコンポーネント
 */
export function AdminPageWrapper({
  children,
  showErrorPage = false
}: AdminPageWrapperProps) {
  // UserGuardは削除済みのため、直接childrenを返す
  // showErrorPageは将来の機能拡張用に保持
  console.log('showErrorPage:', showErrorPage); // 一時的に使用してエラーを回避
  return <>{children}</>;
}